export const SUGGEST_TOPIC_Q = /* GraphQL */ `
  query SuggestTopic {
    suggestTopic {
      id
      kind
      label
      question
      description
    }
  }
`;

export const RECORD_TOPIC_DECISION_M = /* GraphQL */ `
  mutation RecordTopicDecision($topicId: ID!, $decision: TopicDecision!) {
    recordTopicDecision(topicId: $topicId, decision: $decision)
  }
`;
